import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { JOURNEY_ROUTES } from '../../../../../core/constants/journey-routes';

interface FooterLink {
  label: string;
  route?: string;
  href?: string;
}

interface FooterColumn {
  title: string;
  links: FooterLink[];
}

const COBRANZA_PDF = 'https://front-colombia.s3.us-east-2.amazonaws.com/docs/TYC+-+06-+2026/POL%C3%8DTICAS_COBRANZA_RAYO_v2.pdf';

/** Footer of the origination journey only (PDF 3.3); the site footer stays as it is until Legal decides. */
@Component({
  selector: 'app-journey-footer',
  standalone: true,
  imports: [NgFor, NgIf, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './journey-footer.component.html',
})
export class JourneyFooterComponent {
  readonly year = new Date().getFullYear();

  readonly columns: FooterColumn[] = [
    {
      title: 'Cliente',
      links: [
        { label: 'Mi cuenta Rayo', route: '/auth/login' },
        { label: 'Medios de pago', route: '/medios-de-pago' },
        { label: 'PQRS', route: '/pqr-principal' },
      ],
    },
    {
      title: 'Links de interés',
      links: [
        { label: 'Quiénes somos', route: '/quienes-somos' },
        { label: 'Beneficios', route: '/beneficios' },
        { label: 'Testimonios', route: '/testimonios' },
        { label: 'Blog', route: '/blog' },
      ],
    },
    {
      title: 'Préstamos',
      links: [
        { label: 'Solicita tu cupo', route: JOURNEY_ROUTES.SIMULADOR },
        { label: 'Requisitos', route: '/requisitos' },
        { label: 'Calcula tu crédito', route: '/calcula-tu-credito' },
      ],
    },
    {
      title: 'Áreas de servicio',
      links: [
        { label: 'Préstamos en línea', route: '/servicios' },
        { label: 'Renovación de tu préstamo', route: '/servicios' },
        { label: 'Gestión de cobros', route: '/cobranzas-externas' },
        { label: 'Atención al cliente', route: '/pqr-principal' },
      ],
    },
    {
      title: 'Información útil',
      links: [
        { label: 'Preguntas frecuentes', route: '/ayuda' },
        { label: 'Regulación de tasas', href: 'https://www.superfinanciera.gov.co/' },
        { label: 'Cobranzas externas autorizadas', route: '/cobranzas-externas' },
        { label: 'Superintendencia de Industria y Comercio', href: 'https://sedeelectronica.sic.gov.co/' },
      ],
    },
  ];

  readonly legalLinks: FooterLink[] = [
    { label: 'Políticas de Privacidad', route: '/politicas-privacidad' },
    { label: 'Políticas de Privacidad Web/App Rayo', route: '/politicas-web-app' },
    { label: 'Política de Cobranza', href: COBRANZA_PDF },
    { label: 'Términos y Condiciones', route: '/tyc-generales' },
    { label: 'Términos y Condiciones Campañas', route: '/campanas' },
  ];

  readonly countries: FooterLink[] = [
    { label: 'Colombia', href: 'https://rayocredit.com/co/' },
    { label: 'Costa Rica', href: 'https://rayo.cr' },
    { label: 'México', href: 'https://rayocredit.com/mx/' },
  ];
}
